import React, { useContext, useState } from 'react'
import Chip from '@mui/material/Chip'
import Stack from '@mui/material/Stack'
import RedeemIcon from '@mui/icons-material/Redeem'
import ProductContext from '../context/ProductContext'
import { useTranslation } from 'react-i18next'
import AfterPayChip from './AfterPayChip'
import makeStyles from '@mui/styles/makeStyles'
import ResponsiveDialog from '@components/ResponsiveDialog'
import ShippingDiscountChip from './ShippingDiscountChip'

const useStyles = makeStyles(() => ({
  contentWrapper: {
    '& img': {
      maxWidth: '100%',
    },
  },
}))

const ProductChips: React.FC = () => {
  const { t } = useTranslation()

  const { reflection, selectedVariant } = useContext(ProductContext)
  const classes = useStyles()

  const [rewardProgramDialogIsOpen, setRewardProgramDialogIsOpen] = useState(false)

  const product = reflection?.product
  const priceRange = selectedVariant?.priceRange || product?.priceRange
  const sale = priceRange.discount.max < priceRange.undiscount.max
  const rewardProgram = product?.rewardPrograms && product.rewardPrograms[0]
  return (
    <>
      <div className='mb-20'>
        <Stack direction='row' spacing={1} useFlexGap sx={{ flexWrap: 'wrap' }}>
          {!sale && !!rewardProgram && (
            <Chip
              icon={<RedeemIcon color='secondary' />}
              label={t('button.rewardingProgram', 'Rewarding program')}
              variant='outlined'
              classes={{ label: 'ml-5 uppercase text-11 font-semibold' }}
              sx={{ color: '#555', padding: '0 5px', borderRadius: '25px', '&:hover': { backgroundColor: 'inherit' } }}
              onClick={() => setRewardProgramDialogIsOpen(true)}
            />
          )}
          <AfterPayChip currency={priceRange.currency} />
          <ShippingDiscountChip />
        </Stack>
      </div>
      <ResponsiveDialog isOpenDialog={rewardProgramDialogIsOpen} setIsOpenDialog={setRewardProgramDialogIsOpen}>
        <div className={classes.contentWrapper} dangerouslySetInnerHTML={{ __html: rewardProgram?.description }} />
      </ResponsiveDialog>
    </>
  )
}

export default ProductChips
